import { ready } from '~/core';
import { addEvents } from '~/utils';


ready('dropDownLinks', '.dropDownLinks', item => {
	item.addEventListener("click", () => {
    item.classList.toggle('is-active');
  }, true);

  const stickyItem = document.querySelector(".pageCols-rail--sticky");
  const observer = new IntersectionObserver( 
    (entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio === 1) {
          entry.target.classList.remove("is-pinned")
        }
        else if (entry.intersectionRatio < 1){
          entry.target.classList.add("is-pinned")
        }
      });
    },
  { threshold: [1] }
  );
  observer.observe(stickyItem);
});
